export const shoulderMoveText = {
  values: [
    { value: 'ShoulderMove', text: 'Ja', score: 1 },
    { value: 'ShoulderMove', text: 'Nei', score: 0 },
  ],
};
